export default __webpack_public_path__ + "static/media/SavedSearchesIcon.c3531a1a.svg";